/**
 * Kiosk Mode Configuration
 * Central configuration for kiosk mode features and settings
 */

export const KIOSK_CONFIG = {
  // Timing settings (in milliseconds)
  INACTIVITY_TIMEOUT: 0,        // 0 disables auto attract mode
  ATTRACT_MODE_TIMEOUT: 0,     // 0 disables auto attract mode (when hidden)
  LONG_PRESS_DELAY: 2000,          // 2 seconds for long press reset
  
  // UI Settings
  RESET_BUTTON_SIZE: 60,           // Size of reset button in pixels
  RESET_BUTTON_OPACITY: 0.3,      // Default opacity of reset button
  HELP_AUTO_SHOW: true,            // Show help on first visit
  
  // Security settings
  PREVENT_CONTEXT_MENU: true,      // Prevent right-click menu
  PREVENT_TEXT_SELECTION: true,    // Prevent text selection
  PREVENT_DRAG_DROP: true,         // Prevent drag and drop
  DISABLE_ZOOM: true,              // Disable pinch-to-zoom

  // Admin features
  ADMIN_TRIPLE_TAP: true,          // Enable admin panel with triple tap
  ADMIN_DEBUG_MODE: false,         // Enable debug logging
  
  // Performance settings
  AUTO_CLEANUP: true,              // Auto cleanup resources
  CACHE_IMAGES: true,              // Cache images for performance
  
  // Reset behavior
  RESET_ON_INACTIVITY: false,      // Auto-reset on long inactivity
  CLEAR_LOCALSTORAGE: true,        // Clear localStorage on reset
  
  // Help content
  HELP_CONTENT: {
    title: {
      en: 'Product Designer Kiosk',
      cn: '产品设计亭'
    },
    instructions: [
      {
        icon: '🎨',
        text: {
          en: 'Design your product by selecting colors, adding text, and uploading images',
          cn: '通过选择颜色、添加文字和上传图片来设计您的产品'
        }
      },
      {
        icon: '👆',
        text: {
          en: 'Touch and drag to move elements around',
          cn: '触摸并拖动来移动元素'
        }
      },
      {
        icon: '📱',
        text: {
          en: 'Pinch to zoom for detailed work',
          cn: '捏合缩放进行精细操作'
        }
      },
      {
        icon: '💾',
        text: {
          en: 'Your design auto-saves when completed',
          cn: '设计完成后自动保存'
        }
      },
      {
        icon: '🔄',
        text: {
          en: 'Long press anywhere for 2 seconds to reset',
          cn: '长按任意位置2秒重置'
        }
      }
    ],
    startButton: {
      en: 'Start Designing',
      cn: '开始设计'
    }
  },
  
  // Reset confirmation
  RESET_CONFIRMATION: {
    title: {
      en: 'Reset Design?',
      cn: '重置设计？'
    },
    message: {
      en: 'This will clear your current design and start over.',
      cn: '这将清除您当前的设计并重新开始。'
    },
    confirmButton: {
      en: 'Reset',
      cn: '重置'
    },
    cancelButton: {
      en: 'Cancel',
      cn: '取消'
    }
  },
  
  // Attract mode content
  ATTRACT_CONTENT: {
    title: {
      en: 'Touch to Start',
      cn: '触摸开始'
    },
    subtitle: {
      en: 'Design Your Custom Product',
      cn: '设计您的定制产品'
    }
  }
};

// Export default for easy import
export default KIOSK_CONFIG;
